import { DataGrid } from '@mui/x-data-grid';
import { Skeleton } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIssuesList,
  selectPaymodeReport,
  setIssuedSummeryList,
  setPaymodeSaleReport,
} from '../../../utility/Redux/list';
import { FormatNumber3, FormatNumber2 } from '../../../utility/component/tools';
import {
  selectSpinnerLoading,
  setloading,
  setSessionExpired,
  setSpinnerLoading,
  setStationWiseIssueReportModalStatus,
} from '../../../utility/Redux/modal';
import { selectToken } from '../../../utility/Redux/security';
import { SelectDate } from '../../../utility/Redux/refresh';
import { AdminTotalFooter } from '../../../utility/component/FootrAdmnDashboard';
import { setStationWiseIssueReportApiDetails } from '../../../utility/Redux/tableOrder';
import StationWiseIssueModal from './biiling/modal/modStationWiseIssueReport';
import { selectPrefix } from '../../../utility/Redux/profile';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LinearScale,
} from 'chart.js';
import { useLocation } from 'react-router-dom';
import { FromToDateDashBoard } from '../../../utility/component/fromToDateDashboard';
import DashCollectionsButton from '../../../utility/component/dashCollectionsButton';
import { CallAPIPromise } from './biiling/modal/comman';
import moment from 'moment';
import { Pie } from 'react-chartjs-2';
ChartJS.register(ArcElement, Tooltip, Legend, LinearScale);
const width = (window.innerWidth * 1) / 100;
function generateRandomColors(count) {
  const colors = [];
  for (let i = 0; i < count; i++) {
    const color = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(
      Math.random() * 256
    )}, ${Math.floor(Math.random() * 256)}, 0.6)`;
    colors.push(color);
  }
  return colors;
}

const columns = [
  {
    field: 'SID',
    type: 'string',
    width: width * 6,
    align: 'center',
    headerClassName: 'super-app-theme--header ',
    renderHeader: (params) => (
      <strong
        className="text-[#555a66] w-20 text-center leading-4 whitespace-normal"
        style={{ fontSize: 13 }}
      >
        {' '}
        {'Station Id'}{' '}
      </strong>
    ),
  },

  {
    field: 'SNAME',
    type: 'string',
    flex: 1,
    headerClassName: 'super-app-theme--header',
    headerAlign: 'center',
    renderHeader: (params) => (
      <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
        {' '}
        Station Name{' '}
      </strong>
    ),
  },

  {
    field: 'IQNTY',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 6,
    cellClassName: 'super-app-theme--cell',
    headerAlign: 'center',
    align: 'right',
    renderCell: (params) => {
      if (params.value) {
        return <div>{FormatNumber3(params.value)} </div>;
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong className="text-[#555a66] " style={{ fontSize: 13 }}>
        {' '}
        Issued Qnty
      </strong>
    ),
  },

  {
    field: 'IAMOUNT',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 7,
    cellClassName: 'super-app-theme--cell',
    headerAlign: 'center',
    align: 'right',
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber2(params.value);
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong className="text-[#555a66]  " style={{ fontSize: 13 }}>
        {' '}
        Issued Amt.
      </strong>
    ),
  },

  {
    field: 'SQNTY',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 6,

    headerAlign: 'center',
    align: 'right',
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber3(params.value);
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong className="text-[#555a66]  " style={{ fontSize: 13 }}>
        {' '}
        Sales Qnty
      </strong>
    ),
  },

  {
    field: 'AMOUNT',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 7,
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber2(params.value);
      } else {
        return '';
      }
    },
    headerAlign: 'center',
    align: 'right',

    renderHeader: (params) => (
      <strong className="text-[#555a66] " style={{ fontSize: 13 }}>
        {' '}
        Sale Amount
      </strong>
    ),
  },

  {
    field: 'BAL_QNTY',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 7,
    cellClassName: 'super-app-theme--cell',
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber3(params.value);
      } else {
        return '';
      }
    },
    headerAlign: 'center',
    align: 'right',

    renderHeader: (params) => (
      <strong className="text-[#555a66] text-center " style={{ fontSize: 13 }}>
        {' '}
        Balance Qnty
      </strong>
    ),
  },

  {
    field: 'BAL_AMT',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 7,
    cellClassName: 'super-app-theme--cell',
    headerAlign: 'center',
    align: 'right',
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber2(params.value);
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong className="text-[#555a66] " style={{ fontSize: 13 }}>
        {' '}
        Balance Amt.
      </strong>
    ),
  },

  {
    field: 'CASH_AMOUNT',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 7,
    align: 'right',
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber2(params.value);
      } else {
        return '';
      }
    },
    headerAlign: 'center',

    renderHeader: (params) => (
      <strong
        className="text-[#555a66] w-16 text-center leading-4 whitespace-normal"
        style={{ fontSize: 13 }}
      >
        Cash Amt.
      </strong>
    ),
  },

  {
    field: 'CARD_AMOUNT',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 7,
    align: 'right',
    headerAlign: 'center',
    headerAlign: 'center',
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber2(params.value);
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong
        className="text-[#555a66] text-center w-16 leading-4 whitespace-normal"
        style={{ fontSize: 13 }}
      >
        Card Amt.
      </strong>
    ),
  },

  {
    field: 'EPAYMENT',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 7,
    align: 'right',
    headerAlign: 'center',
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber2(params.value);
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong
        className="text-[#555a66] w-16 leading-4 whitespace-normal"
        style={{ fontSize: 13 }}
      >
        {' '}
        ePayment
      </strong>
    ),
  },

  {
    field: 'CHEQUE_AMOUNT',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 7,
    align: 'right',
    headerAlign: 'center',
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber2(params.value);
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong className="text-[#555a66] " style={{ fontSize: 13 }}>
        {' '}
        Cheque Amt.
      </strong>
    ),
  },

  {
    field: 'BTC_AMOUNT',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 6,
    align: 'right',
    headerAlign: 'center',
    renderCell: (params) => {
      if (params.value) {
        return <div>{FormatNumber2(params.value)} </div>;
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong
        className="text-[#555a66] w-16 text-center leading-4 whitespace-normal"
        style={{ fontSize: 13 }}
      >
        {' '}
        Btc Amt.
      </strong>
    ),
  },
  {
    field: 'DISQ_AMT',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 7,
    align: 'right',
    headerAlign: 'center',
    renderCell: (params) => {
      if (params.value) {
        return <div className="pr-4">{FormatNumber2(params.value)} </div>;
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong
        className="text-[#555a66] w-16 text-center leading-4 whitespace-normal"
        style={{ fontSize: 13 }}
      >
        {' '}
        Disq Amt.
      </strong>
    ),
  },
];
const columnsMobile = [
  {
    field: 'SID',
    type: 'string',
    width: width * 15,
    align: 'center',
    headerClassName: 'super-app-theme--header ',
    renderHeader: (params) => (
      <strong
        className="text-[#555a66]  text-center leading-4 whitespace-normal"
        style={{ fontSize: 11 }}
      >
        {' '}
        {'station'}{' '}
      </strong>
    ),
  },
  // {
  //   field: 'SNAME',
  //   type: 'string',
  //   width: width * 30,
  //   headerClassName: 'super-app-theme--header',
  //   headerAlign: 'center',
  //   renderHeader: (params) => (
  //     <strong className="text-[#555a66]" style={{ fontSize: 11 }}>
  //       {' '}
  //       Station{' '}
  //     </strong>
  //   ),
  // },

  {
    field: 'IQNTY',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 20,
    headerAlign: 'center',
    align: 'right',
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber3(params.value);
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong
        className="text-[#555a66] w-12 text-center leading-4 whitespace-normal"
        style={{ fontSize: 11 }}
      >
        {' '}
        Issued Qnty
      </strong>
    ),
  },

  {
    field: 'IAMOUNT',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 20,
    headerAlign: 'center',
    align: 'right',
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber2(params.value);
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong
        className="text-[#555a66] w-12 text-center leading-4 whitespace-normal "
        style={{ fontSize: 11 }}
      >
        {' '}
        Issued Amt.
      </strong>
    ),
  },
  {
    field: 'SQNTY',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    flex: 1,

    headerAlign: 'center',
    align: 'right',
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber3(params.value);
      } else {
        return '';
      }
    },
    renderHeader: (params) => (
      <strong
        className="text-[#555a66]  w-12 text-center leading-4 whitespace-normal "
        style={{ fontSize: 11 }}
      >
        {' '}
        Sales Qnty
      </strong>
    ),
  },

  {
    field: 'AMOUNT',
    type: 'number',
    headerClassName: 'super-app-theme--header',
    width: width * 20,
    valueFormatter: (params) => {
      if (params.value) {
        return FormatNumber2(params.value);
      } else {
        return '';
      }
    },
    headerAlign: 'center',
    align: 'right',

    renderHeader: (params) => (
      <strong
        className="text-[#555a66] text-center w-16 leading-4 whitespace-normal"
        style={{ fontSize: 11 }}
      >
        {' '}
        Amount
      </strong>
    ),
  },
];

const AdminDashboard2 = () => {
  const location = useLocation();

  const token = useSelector(selectToken);
  const prefix = useSelector(selectPrefix);
  const checkDateData = useSelector(SelectDate);
  const issuedSummeryList = useSelector(selectIssuesList);
  const currency = location?.state?.currency;
  const [currentWeekPaymode, setCurrentWeekPaymode] = useState([]);
  const [currentMonthlyPaymode, setCurrentMonthlyPaymode] = useState([]);
  const [currentMonthlyPaymodeChart, setCurrentMonthlyPaymodeChart] = useState(
    []
  );
  const spinnerloading = useSelector(selectSpinnerLoading);
  const [bgList2, setBgList2] = useState([]);
  const [bgList3, setBgList3] = useState([]);

  const dispatch = useDispatch();

  const weeklyData = {
    labels: currentWeekPaymode.map((o) => o.DAY_NAME),
    datasets: [
      {
        label: 'Sale',
        data: currentWeekPaymode.map(
          (o) =>
            o.CASH_AMOUNT +
            o.BTC_AMOUNT +
            o.CARD_AMOUNT +
            o.EPAYMENT +
            o.CHEQUE_AMOUNT
        ),
        backgroundColor: bgList2,
        hoverBackgroundColor: bgList2,
      },
    ],
  };

  const monthlyData = {
    labels: currentMonthlyPaymodeChart.map((o) => o.YEAR_MONTH),
    datasets: [
      {
        label: 'Sale',
        data: currentMonthlyPaymodeChart.map(
          (o) =>
            o.CASH_AMOUNT +
            o.BTC_AMOUNT +
            o.CARD_AMOUNT +
            o.EPAYMENT +
            o.CHEQUE_AMOUNT
        ),
        backgroundColor: bgList3,
        hoverBackgroundColor: bgList3,
      },
    ],
  };
  const paymodeReport = useSelector(selectPaymodeReport);

  const getIssuedData = (date) => {
    dispatch(setSpinnerLoading('Loading'));
    const data = {
      table_prefix: prefix,
      // station_id: "",
      from_date: date ? date : checkDateData,
      to_date: date ? date : checkDateData,
    };
    CallAPIPromise(
      `/api/dashBoardManager/stationWiseIssued`,
      data,
      token,
      dispatch
    )
      .then((res) => {
        console.log(res);

        if (!res.data.error) {
          const data = res.data.response;

          dispatch(setIssuedSummeryList(data));
          getPaymodeDetails(date);
        }
      })
      .catch((e) => {
        console.log(e);
        if (e.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  const getPaymodeDetails = (date) => {
    dispatch(setloading(true));
    const data = {
      table_prefix: prefix,
      sid: '',
      from_date: date ? date : checkDateData,
      to_date: date ? date : checkDateData,
    };
    CallAPIPromise(`/api/dashBoradReports/payModeSale`, data, token, dispatch)
      .then((res) => {
        console.log(res);
        if (!res.data.error) {
          if (res.data.response[0]) {
            dispatch(setPaymodeSaleReport(res.data.response));
          }
        }
      })
      .catch((e) => {
        console.log(e);

        if (e.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setloading(false));
        getPaymodeDetailsCurrentWeek();
      });
  };
  const getPaymodeDetailsCurrentWeek = (date) => {
    dispatch(setloading(true));
    const data = {
      table_prefix: prefix,
      sid: '',
      from_date: date ? date : checkDateData,
      to_date: date ? date : checkDateData,
    };
    CallAPIPromise(
      `/api/dashBoardManager/paymode_Current_Week_Sum`,
      data,
      token,
      dispatch
    )
      .then((res) => {
        console.log(res);
        if (!res.data.error) {
          if (res.data.response[0]) {
            setCurrentWeekPaymode(res.data.response);
            setBgList2(generateRandomColors(res.data.response.length));
          }
        }
      })
      .catch((e) => {
        console.log(e);

        if (e.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setloading(false));
        getPaymodeDetailsMonthly();
      });
  };

  const getPaymodeDetailsMonthly = (date) => {
    dispatch(setloading(true));
    const data = {
      table_prefix: prefix,
      sid: '',
      from_date: date ? date : checkDateData,
      to_date: date ? date : checkDateData,
    };
    CallAPIPromise(
      `/api/dashBoardManager/paymode_Monthly_Sum`,
      data,
      token,
      dispatch
    )
      .then((res) => {
        console.log(res);
        if (!res.data.error) {
          if (res.data.response[0]) {
            setCurrentMonthlyPaymode([
              ...res.data.response,
              {
                YEAR_MONTH: 'Total Sale',
                CASH_AMOUNT: res.data.response.reduce(
                  (acc, row) => acc + Number(row.CASH_AMOUNT),
                  0
                ),
                BTC_AMOUNT: res.data.response.reduce(
                  (acc, row) => acc + Number(row.BTC_AMOUNT),
                  0
                ),
                CARD_AMOUNT: res.data.response.reduce(
                  (acc, row) => acc + Number(row.CARD_AMOUNT),
                  0
                ),
                EPAYMENT: res.data.response.reduce(
                  (acc, row) => acc + Number(row.EPAYMENT),
                  0
                ),
                CHEQUE_AMOUNT: res.data.response.reduce(
                  (acc, row) => acc + Number(row.CHEQUE_AMOUNT),
                  0
                ),
              },
            ]);
            setCurrentMonthlyPaymodeChart(res.data.response);
            setBgList3(generateRandomColors(res.data.response.length));
          }
        }
      })
      .catch((e) => {
        console.log(e);

        if (e.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setloading(false));
      });
  };
  useEffect(() => {
    if (!currentWeekPaymode[0]) {
      getIssuedData();
    }
  }, []);
  const c = window.innerWidth <= 768 ? columnsMobile : columns;
  const getMonthGradient = (monthNumber) => {
    // monthNumber: 0 = Jan, 11 = Dec
    if (monthNumber >= 2 && monthNumber <= 4) {
      // Spring: Mar-May
      return 'linear-gradient(135deg, #a8d5ba, #f7d6e0)'; // Soft Green → Powder Pink
    } else if (monthNumber >= 5 && monthNumber <= 7) {
      // Summer: Jun-Aug
      return 'linear-gradient(135deg, #cce7f0, #ffd5c2)'; // Powder Blue → Light Coral
    } else if (monthNumber >= 8 && monthNumber <= 10) {
      // Autumn/Fall: Sep-Nov
      return 'linear-gradient(135deg, #f7c59f, #e6b89c)'; // Powder Orange → Dusty Brown
    } else {
      // Winter: Dec-Feb
      return 'linear-gradient(135deg, #dfe7ec, #c7dff0)'; // Powder Grey → Icy Blue
    }
  };
  return (
    <div className=" overflow-y-scroll h-full  p-2   flex flex-col   ">
      <div style={{ height: '100%' }}>
        <FromToDateDashBoard
          refresh={getIssuedData}
          getIssuedData={getIssuedData}
        />

        {/* Today Sales */}
        <div
          style={{
            border: '1px solid #bebaba', // soft gray
            fontSize: '13px',
            fontWeight: '500',
            backgroundColor: '#0d0d0d', // dark header
          }}
          className="w-fit flex items-center gap-2 mb-2 mt-3 text-white rounded-br-3xl"
        >
          <div className="bg-[#f5874f] px-3 py-1 ">₹</div>
          <div className="py-1 pr-6">Today Sales</div>
        </div>

        {/* Today Collection Cards */}
        <div className="pt-3">
          {paymodeReport[0] ? (
            <div className="grid grid-cols-2 md:grid-cols-4 ll:grid-cols-7 gap-2">
              <DashCollectionsButton
                mode="Cash"
                payment={FormatNumber2(paymodeReport[0]?.CASH_AMOUNT)}
                currency={currency}
                bg="#b0e0e6" // powder blue
                iconBg="#98cdd8"
              />

              <DashCollectionsButton
                mode="Card"
                payment={FormatNumber2(paymodeReport[0]?.CARD_AMOUNT)}
                currency={currency}
                bg="#f6d1d1" // powder pink
                iconBg="#ecbebe"
              />

              <DashCollectionsButton
                mode="Cheque"
                payment={FormatNumber2(paymodeReport[0]?.CHEQUE_AMOUNT)}
                currency={currency}
                bg="#e6e6fa" // powder lavender
                iconBg="#cfcfe9"
              />

              <DashCollectionsButton
                mode="ePayment"
                payment={FormatNumber2(paymodeReport[0]?.EPAYMENT)}
                currency={currency}
                bg="#fff8dc" // powder yellow
                iconBg="#f5eec0"
              />

              <DashCollectionsButton
                mode="BTC"
                payment={FormatNumber2(paymodeReport[0]?.BTC_AMOUNT)}
                currency={currency}
                bg="#d4f1d4" // powder green
                iconBg="#b9e3b9"
              />

              <DashCollectionsButton
                mode="Discount"
                payment={FormatNumber2(paymodeReport[0]?.DISQ_AMT)}
                currency={currency}
                bg="#f5d0d0" // subtle powder red
                iconBg="#f0bcbc"
              />
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-4 ll:grid-cols-7 gap-2">
              {[1, 2, 3, 4, 5, 6, 7].map((e, k) => (
                <Skeleton
                  key={k}
                  variant="rectangular"
                  animation="wave"
                  height={58}
                  sx={{
                    fontSize: '1rem',
                    borderRadius: '7px',
                    marginRight: '6px',
                    paddingX: '12px',
                  }}
                />
              ))}
            </div>
          )}
        </div>

        {/* Weekly Sales */}
        <div
          style={{
            border: '1px solid #bebaba',
            fontSize: '13px',
            fontWeight: '500',
            backgroundColor: '#0d0d0d',
          }}
          className="w-fit flex items-center gap-2 mb-2 mt-4 text-white rounded-br-3xl"
        >
          <div className="bg-[#f5874f] px-2 py-1 ">📅</div>
          <div className="py-1 pr-6">Weekly Sales</div>
        </div>
        <div className="flex flex-1">
          <div className="grid grid-cols-1 flex-1 md:grid-cols-3 gap-4 mt-3">
            {currentWeekPaymode.map((item, index) => (
              <div
                key={index}
                className="bg-[#fff8dc] text-gray-800 rounded-2xl shadow-sm p-4 hover:shadow-md transition"
              >
                <h2 className="text-lg font-semibold">
                  {item.DAY_NAME} -{' '}
                  {moment(item.DAY_DATE).format('MMM DD YYYY')}
                </h2>

                <div className="mt-3 space-y-2 text-sm">
                  <p className="flex justify-between">
                    <span>💵 Cash</span>
                    <span>₹{FormatNumber2(item.CASH_AMOUNT)}</span>
                  </p>
                  <p className="flex justify-between">
                    <span>₿ BTC</span>
                    <span>{FormatNumber2(item.BTC_AMOUNT)}</span>
                  </p>
                  <p className="flex justify-between">
                    <span>💳 Card</span>
                    <span>₹{FormatNumber2(item.CARD_AMOUNT)}</span>
                  </p>
                  <p className="flex justify-between">
                    <span>📱 ePayment</span>
                    <span>₹{FormatNumber2(item.EPAYMENT)}</span>
                  </p>
                  <p className="flex justify-between">
                    <span>🏦 Cheque</span>
                    <span>₹{FormatNumber2(item.CHEQUE_AMOUNT)}</span>
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="ml-2">
            <div
              style={{
                height:
                  width < 500
                    ? '300px'
                    : currentWeekPaymode.length < 5
                    ? `${100 * currentWeekPaymode.length}PX`
                    : '400px',
                width:
                  width < 500
                    ? '300px'
                    : currentWeekPaymode.length < 5
                    ? `${100 * currentWeekPaymode.length}PX`
                    : '400px',
                marginTop: '20px',
                marginBottom: '20px',
              }}
            >
              <div className="text-sm flex justify-center font-semibold">
                Weekly Sale Chart
              </div>
              <Pie data={weeklyData} />
            </div>
          </div>
        </div>

        {/* Monthly Sales */}
        <div
          style={{
            border: '1px solid #bebaba',
            fontSize: '13px',
            fontWeight: '500',
            backgroundColor: '#0d0d0d',
          }}
          className="w-fit flex items-center gap-2 mb-2 mt-4 text-white rounded-br-3xl"
        >
          <div className="bg-[#f5874f] px-2 py-1 ">📊</div>
          <div className="py-1 pr-3">Monthly Sales</div>
        </div>
        <div className="flex flex-1">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 flex-1 ">
            {currentMonthlyPaymode.map((item, index) => {
              const monthNum = new Date(item.YEAR_MONTH + '-01').getMonth(); // extract month
              const gradient = getMonthGradient(monthNum);
              return (
                <div
                  key={index}
                  className="text-gray-800 pb-3 rounded-2xl shadow-md p-4 hover:shadow-lg transition"
                  style={{
                    background:
                      item.YEAR_MONTH !== 'Total Sale'
                        ? gradient
                        : 'linear-gradient(135deg, #4facfe, #43e97b)',
                  }}
                >
                  <h2
                    style={{
                      backgroundColor:
                        item.YEAR_MONTH === 'Total Sale'
                          ? 'white'
                          : 'transparent',
                    }}
                    className="text-lg rounded-sm py-1 px-2  font-semibold"
                  >
                    {item.YEAR_MONTH}
                  </h2>

                  <div className="mt-3 space-y-2 text-sm">
                    <p className="flex justify-between">
                      <span>💵 Cash</span>
                      <span>₹{FormatNumber2(item.CASH_AMOUNT)}</span>
                    </p>
                    <p className="flex justify-between">
                      <span>₿ BTC</span>
                      <span>{FormatNumber2(item.BTC_AMOUNT)}</span>
                    </p>
                    <p className="flex justify-between">
                      <span>💳 Card</span>
                      <span>₹{FormatNumber2(item.CARD_AMOUNT)}</span>
                    </p>
                    <p className="flex justify-between">
                      <span>📱 ePayment</span>
                      <span>₹{FormatNumber2(item.EPAYMENT)}</span>
                    </p>
                    <p className="flex justify-between">
                      <span>🏦 Cheque</span>
                      <span>₹{FormatNumber2(item.CHEQUE_AMOUNT)}</span>
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="ml-2">
            <div
              style={{
                height:
                  width < 500
                    ? '300px'
                    : currentMonthlyPaymodeChart.length < 5
                    ? `${100 * currentMonthlyPaymodeChart.length}PX`
                    : '400px',
                width:
                  width < 500
                    ? '300px'
                    : currentMonthlyPaymodeChart.length < 5
                    ? `${100 * currentMonthlyPaymodeChart.length}PX`
                    : '400px',
                marginTop: '20px',
                marginBottom: '20px',
              }}
            >
              <div className="text-sm flex justify-center font-semibold">
                Monthly Sale Chart
              </div>
              <Pie data={monthlyData} />
            </div>
          </div>
        </div>
      </div>

      <StationWiseIssueModal />
    </div>
  );
};

export default AdminDashboard2;
